import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { ApplicationStoreService } from '../services/application-store.service';

export const applicationInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(ApplicationStoreService);
  const params = store.getStateParams();

  if (params?.appParameterId) {
    req = addParams(req, params);
  }

  return next(req);
};

function addParams(
  request: HttpRequest<any>,
  args: { appId: any; appParameterId: any }
): HttpRequest<any> {
  if (request.method === 'GET' || request.method === 'POST') {
    return request.clone({
      setParams: {
        app_param_id: args.appParameterId,
        ...request.params,
      },
    });
  }
  return request.clone();
}
